import React from "react";
// import CodeEditor from "@uiw/react-textarea-code-editor";
// import Label from "components/FormElements/Label";
// import LowTextArea from "components/FormElements/LowTextArea";
// import SecondaryButton from "components/Buttons/SecondaryButton";

export default function CopyDesk(props) {
    return (
        <div className="text-center">This feature is under development.</div>
    );
    // return (
    //     <div className="grid grid-cols-10 gap-4">
    //         <div className="col-span-4">
    //             <Label>Comments</Label>
    //             <LowTextArea rows={3} />
    //             <SecondaryButton label="Add Comment" className="mt-2" />
    //         </div>
    //         <div className="col-span-3">
    //             <Label>Notes</Label>
    //             <div className="rounded-md border border-gray-300 bg-white p-3 shadow-sm">
    //                 <CodeEditor
    //                     value=""
    //                     onChange={() => {}}
    //                     language="html"
    //                     padding={2}
    //                     minHeight={100}
    //                     placeholder="Notes, reminders, etc..."
    //                     style={{
    //                         borderLeft: "6px solid #f1f1f1",
    //                         fontSize: 12,
    //                         backgroundColor: "#ffffff",
    //                         fontFamily:
    //                             "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
    //                     }}
    //                 />
    //             </div>
    //         </div>
    //         <div className="col-span-3">
    //             <Label>Files</Label>
    //             <SecondaryButton label="Select Files" className="mt-2" />
    //         </div>
    //     </div>
    // );
}
